import { ChangeEvent, KeyboardEvent, useRef } from "react";
import { useRadioGroup } from "@mui/material";
import { CoreButton, CoreButtonProps } from "./Button";
import styles from "./button.module.css";

export type CoreButtonRadioProps = {
	value: string;
	label: string;
} & CoreButtonProps;

export default function CoreButtonRadio({ value, label, ...buttonProps }: CoreButtonRadioProps) {
	const radioGroup = useRadioGroup();
	const inputRef = useRef<HTMLInputElement>(null);
	const checked = radioGroup ? radioGroup.value === value : false;

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (radioGroup && radioGroup.onChange) {
			radioGroup.onChange(e, value);
		}
	};

	// Radio buttons handle pressing space (" ")
	const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") {
			e.preventDefault();
			inputRef.current?.click();
		}
	};

	return (
		<label>
			<input
				type="radio"
				ref={inputRef}
				className={styles.hiddenInput}
				name={radioGroup?.name}
				value={value}
				checked={checked}
				onChange={handleChange}
				onKeyDown={handleKeyDown}
			/>
			<CoreButton
				key={value}
				checked={checked}
				tabIndex={-1}
				onClick={() => inputRef.current?.click()}
				aria-checked={checked}
				{...buttonProps}
			>
				{label}
			</CoreButton>
		</label>
	);
}
